<template>
    <b-form-group label="Berat Kering">
        <b-row no-gutters>
            <b-col>
                <b-input-group append="Gram">
                    <b-form-input v-model="input.beratKering" name="beratKering" min="0" step="0.01"
                        @blur="$emit('roundPersen')" @wheel="$event.target.blur()" type="number" required></b-form-input>
                </b-input-group>
            </b-col>
            <b-col cols="3" class="ml-2" :hidden="$companyId == 'PGI' ? false : true">
                <b-badge :variant="pdfReadBeratKering == false ? 'danger' : 'primary'"
                    :hidden="seBeratKering == null ? true : false" size="sm"
                    @click="$emit('openModalSE', seBeratKering, 'beratKering', pdfReadBeratKering)" v-b-tooltip.hover
                    title="SE" name="jenisBarangViewBtn">
                    <i class="fa fa-info px-1"></i>
                </b-badge>
                <b-link :to="`${$route.path}/surat-edaran/1`" class="ml-2"
                    :hidden="$companyId == 'PGI' && role == 'Super Admin' ? false : true">
                    <b-badge size="sm" class="table-button view" v-b-tooltip.hover title="Setting SE Berat Kering"
                        name="jenisBarangViewBtn">
                        <i class="fa fa-plus"></i>
                    </b-badge>
                </b-link>
            </b-col>
        </b-row>
    </b-form-group>
</template>
<script>
export default {
    props: {
        input: { required: true },
        pdfReadBeratKering: { required: true },
        seBeratKering: { required: true },
        role: { required: true },
    },
}
</script>
